<template>
  <div class="cashflow-view" v-if="presentedBudget">
    <out-of-date-cashflow-view v-if="outOfDate" />
    <blocked-cashflow-view v-else-if="blocked" />
    <new-pending-cashflow-view v-else-if="newPending" />
    <current-month-cashflow-view v-else-if="isPresentingCurrentMonth" />
    <past-editable-month-cashflow-view v-else />
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import _ from 'lodash';
import OutOfDateCashflowView from './out-of-date-month/OutOfDateCashflowView.vue';
import CurrentMonthCashflowView from './current-month/CurrentMonthCashflowView.vue';
import PastEditableMonthCashflowView from './past-editable-month/PastEditableMonthCashflowView.vue';
import BlockedCashflowView from './blocked-month/BlockedCashflowView.vue';
import NewPendingCashflowView from './pending-month/PendingCashflowView.vue';

export default {
  name: 'CashflowView',
  components: {
    OutOfDateCashflowView,
    CurrentMonthCashflowView,
    PastEditableMonthCashflowView,
    BlockedCashflowView,
    NewPendingCashflowView,
  },
  computed: {
    ...mapGetters('cashflowView', ['isPresentingCurrentMonth', 'presentedBudget']),
    ...mapGetters('applicationState', ['cashflowTypes']),
    ...mapState('applicationState', ['cashflowState']),
    outOfDate() {
      return _.includes([this.cashflowTypes.OUT_OF_DATE, this.cashflowTypes.BUG], this.cashflowState);
    },
    blocked() {
      return _.includes([this.cashflowTypes.BLOCKED], this.cashflowState);
    },
    newPending() {
      return this.cashflowTypes.PENDING === this.cashflowState;
    },
  },
};
</script>

<style lang="scss" scoped>
  .cashflow-view {
  }
</style>



// WEBPACK FOOTER //
// src/pages/responsive-pages/authenticated/navigation-pages/cashflow-app/cashflow-view/CashflowView.vue